import { FCC, Icon, Stack } from '@eluve/components';

const indent = (depth: number) => `${depth * 2}rem`;

export const DepthContainer: FCC<{ depth: number }> = ({ children, depth }) => {
  return (
    <Stack
      style={{ paddingLeft: indent(depth) }}
      className="items-top"
      direction="horizontal"
      gap={2}
      align="stretch"
    >
      {depth > 0 && <Icon name="CornerDownRight" size="xl" className="mt-4" />}
      {children}
    </Stack>
  );
};
